export async function mcpOauthCallback(args: {
  location: string;
  userToken: string;
}) {
  const params = new URLSearchParams(args.location);

  const mcpLoginCallback = params.get("mcp_login_callback");
  const mcpReturnTo = params.get("mcp_return_to");

  if (!mcpLoginCallback || !mcpReturnTo) {
    throw new Error("MCP login callback parameters are missing");
  }

  const callbackUrl = new URL(mcpLoginCallback);
  callbackUrl.search = "";
  callbackUrl.searchParams.set("return_to", mcpReturnTo);

  console.log("callbackUrl", callbackUrl.toString());

  const response = await fetch(callbackUrl.toString(), {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${args.userToken}`,
    },
  });

  console.log(response);

  if (!response.ok) {
    throw new Error("MCP login callback failed");
  }

  const payload = await response.json();

  if (!payload?.resumeUrl) {
    throw new Error("MCP login callback did not return a resumeUrl");
  }

  window.location.assign(payload.resumeUrl);
  return;
}
